export enum TipoDestinatarioAutomacaoOrdemServicoEnum {
  CriadorOrdemServico = 1,
  Perfil = 2,
  Usuario = 3,
}
